import {Component, HostListener, inject, Signal, viewChild} from '@angular/core';
import {ICellEditorParams} from 'ag-grid-community';
import {NgxMaterialTimepickerComponent, NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {Subscription} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CustomCellEditorComponent} from '../custom-cell-editor/custom-cell-editor.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EsvgFiles} from 'frontier/nucleus';
import {TextElementComponent} from '../../../form-control/dynamic-form/form-element/text-element/text-element.component';

@Component({
  selector: 'app-time-of-day-cell-editor',
  templateUrl: './time-of-day-cell-editor.component.html',
  styleUrls: ['../custom-cell-editor/custom-cell-editor.component.scss'],
  standalone: true,
  imports: [NgxMaterialTimepickerModule, FormsModule, ReactiveFormsModule, TextElementComponent],
})
export class TimeOfDayCellEditorComponent extends CustomCellEditorComponent {
  private _datePipe: DatePipe = inject(DatePipe);

  protected readonly EsvgFiles: typeof EsvgFiles = EsvgFiles;

  timePickerInputComponent: Signal<TextElementComponent> = viewChild<TextElementComponent>('inputField');
  timePickerRef: Signal<NgxMaterialTimepickerComponent>
    = viewChild<NgxMaterialTimepickerComponent>(NgxMaterialTimepickerComponent);

  subs: Subscription = new Subscription();
  private timePickerOpen: boolean = false;

  override agInit(params: ICellEditorParams): void {
    super.agInit(params);

    let initialTime: string = '';
    if (params.value?.value) {
      initialTime = this._datePipe.transform(params.value.value, 'HH:mm') || '';
    }

    if (params.charPress) {
      initialTime = params.charPress;
    }

    this.textFormControl.patchValue(initialTime);
  }

  override ngAfterViewInit(): void {
    this.subs.add(
      this.timePickerRef().opened.subscribe((): boolean => (this.timePickerOpen = true))
    );

    this.subs.add(
      this.timePickerRef().closed.subscribe((): void => {
        this.timePickerOpen = false;
        this.params.api.stopEditing();
      })
    );

    setTimeout((): void => {
      const inputEl = this.timePickerInputComponent().inputRef.nativeElement;
      inputEl.focus();

      inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);

      const agParams = this.params as any;

      console.log(this.params);
      const wasDblClick: boolean = this.params.node.data._openedByDblClick;
      delete this.params.node.data._openedByDblClick;

      const wasTyping: boolean = !!this.params.charPress;
      const wasEnter: boolean = agParams.eventKey === 'Enter' || agParams.eventKey === 13;

      if ((wasEnter || wasDblClick) && !wasTyping) {
        this.timePickerRef().open();
      }
    }, 0);
  }

  protected override handlePaste(params: ICellEditorParams): void {
    if (params.charPress === 'delete') {
      this.textFormControl.patchValue('');
      return;
    }

    this.textFormControl.patchValue(params.charPress);
  }

  override isPopup(): boolean {
    return true;
  }

  onTimeChanged(evt: string): void {
    this.textFormControl.patchValue(evt);
  }

  // detect clicks outside
  @HostListener('document:click', ['$event'])
  protected override clickOut(event: MouseEvent): void {
    const target: HTMLElement = event.target as HTMLElement;
    const timePickerContainer: Element = document.getElementsByTagName(
      'ngx-material-timepicker-container'
    )[0];
    if (
      !this._elementRef.nativeElement.contains(target) &&
      (timePickerContainer == undefined ||
        !timePickerContainer.contains(target)) &&
      this.timePickerOpen == false
    ) {
      this.params.api.stopEditing();
    }
  }
}
